import TextField from "@mui/material/TextField";
import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";
import updChar from "../../_sig_api/updChar";

export default function CharWunden() {
    return <Item>
        <TextField InputLabelProps={{shrink: true}}
                   onChange={e => updChar([{k:'wunden',v: parseInt(e.target.value as string)}])}
                   style={{marginLeft: 8, minWidth: "75%"}}
                   value={s_char.value.wunden}
                   variant="standard"
                   type="number"
                   label="Wunden:"
                   name="wunden"/>
    </Item>
}